import { SVGProps } from "react";

const PlusIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
        <g clipPath="url(#a)">
            <path
                fill="currentColor"
                d="M4.93 13.063a1.12 1.12 0 0 1-1.114-1.114 1.12 1.12 0 0 1 1.114-1.113h5.957V4.879A1.12 1.12 0 0 1 12 3.766a1.12 1.12 0 0 1 1.113 1.113v5.957h5.957a1.12 1.12 0 0 1 1.114 1.113 1.12 1.12 0 0 1-1.114 1.114h-5.957v5.957A1.12 1.12 0 0 1 12 20.133a1.12 1.12 0 0 1-1.113-1.113v-5.957H4.93Z"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>
);
export default PlusIcon;
